import React, { useEffect, useState } from "react";
import {
  Container,
  Card,
  Table,
  Button,
  Spinner,
  Form,
  Row,
  Col,
} from "react-bootstrap";
import { FaTrashAlt } from "react-icons/fa";
import axios from "axios";
import toast from "react-hot-toast";
import { BASE_URL } from "../BaseURL";
import ReusableTooltip from "./ReusableTooltip";
import "../Assets/WebsiteCss/comStyle.css";
import "../Assets/WebsiteCss/table.css";

const Categories = () => {
  const [categories, setCategories] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [loading, setLoading] = useState(true);
  const [btnLoading, setBtnLoading] = useState(false);
  const getCategories = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/api/category/get-category`);
      setCategories(res.data.data || res.data);
    } catch (error) {
      toast.error("Failed to load categories");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCategories();
  }, []);
  const handleAddCategory = async (e) => {
    e.preventDefault();

    if (!categoryName.trim()) {
      toast.error("Category name is required");
      return;
    }

    try {
      setBtnLoading(true);
      await axios.post(`${BASE_URL}/api/category/add-category`, {
        categoryName,
      });
      toast.success("Category added successfully");
      setCategoryName("");
      getCategories();
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to add category");
    } finally {
      setBtnLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this category?"))
      return;

    try {
      await axios.delete(`${BASE_URL}/api/category/delete-category/${id}`);
      toast.success("Category deleted successfully");
      getCategories();
    } catch (error) {
      toast.error("Failed to delete category");
    }
  };

  return (
    <Container className="mt-4 container-lg p-0">
      <Card>
        {/* HEADER */}
        <Card.Header className="mainBGColor text-white fw-bold px-3 py-2">
          Categories
        </Card.Header>

        <Card.Body>
          {/* ADD CATEGORY */}
          <Form onSubmit={handleAddCategory} className="mb-4">
            <Row className="align-items-end">
              <Col md={6}>
                <Form.Label>Category Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter category name"
                  value={categoryName}
                  onChange={(e) => setCategoryName(e.target.value)}
                />
              </Col>

              <Col md={3}>
                <Button
                  type="submit"
                  className=""
                  disabled={btnLoading}
                  style={{
                    padding: "6px 14px",
                    fontSize: "13px",
                  }}
                >
                  {btnLoading ? "Adding..." : "Add Category"}
                </Button>
              </Col>
            </Row>
          </Form>

          {/* TABLE */}
          {loading ? (
            <div className="text-center py-4">
              <Spinner animation="border" />
            </div>
          ) : (
            <Table bordered hover striped responsive className="user-table">
              <thead>
                <tr>
                  <th style={{ width: "80px" }}>Sr No.</th>
                  <th>Category</th>
                  <th style={{ width: "100px" }}>Action</th>
                </tr>
              </thead>

              <tbody>
                {categories.length === 0 ? (
                  <tr>
                    <td colSpan="3" className="text-center">
                      --- No Categories Found ---
                    </td>
                  </tr>
                ) : (
                  categories.map((cat, index) => (
                    <tr key={cat._id}>
                      <td>{index + 1}</td>
                      <td>{cat.categoryName}</td>
                      <td>
                        <ReusableTooltip text="Delete">
                          <Button
                            className="deleteicon"
                            onClick={() => handleDelete(cat._id)}
                            style={{
                              padding: "4px 6px",
                              fontSize: "12px",
                              lineHeight: "1",
                            }}
                          >
                            <FaTrashAlt size={12} />
                          </Button>
                        </ReusableTooltip>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Categories;
